(function () {
  'use strict';
  angular.module('vcexam')
    .component('gdtprofilconfig', {
      restrict: 'E',
      bindings: {},
      template: `
        <div class="panel panel-info">
        <div class="panel-heading">
          <h3>GDT Profil</h3>
        </div>
        <div class="panel-body"></div>
          <div class="modalspacer">
            <label>Name des in der Software eingrichteten Profils</label>
            <listeditor list="vm.gdtprofil.gdtprofil" parentsave="vm.childsavepat(list)"></listeditor>
          </div>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Config', 'Rlog', 'vertxEventBusService',
        function ($log, Config, Rlog, vertxEventBusService) {
          let vm = this;
          vm.childsavepat = childsavepat;

          vm.$onInit = function () {

            Config.$find('gdtprofil').$then(function (gdtprofil) {
              vm.gdtprofil = gdtprofil;
              // intialize if still empty
              if (angular.isUndefined(vm.gdtprofil.gdtprofil)) {
                vm.gdtprofil._id = 'gdtprofil';
                vm.gdtprofil.gdtprofil = [];
              }
            });
          };

          function childsavepat(list) {
            vm.gdtprofil.gdtprofil = list;
            savepat();
          }

          function savepat() {
            if (vm.gdtprofil.$hasPendingActions()) {
              vm.gdtprofil.$cancel();
            }
            vm.gdtprofil.$save();
          }

          const configUpdateHandler = function (message) {
            let messages = message.split(':');
            if (messages[0] === 'gdtprofil') {
              if (angular.isDefined(vm.gdtprofil)){
                vm.gdtprofil.$refresh().$then(function () {
                  $log.debug('debug: config refresh gdtprofil');
                }, function (error) {
                  $log.debug('debug: config refresh gdtprofil failed: ', error);
                });
              }
            }
          };

          vertxEventBusService.on('config.update', {}, configUpdateHandler);

          vm.$onDestroy = function () {
            $log.debug('[Vert.x unsubscribe] config.update');
            vertxEventBusService.unregisterHandler('config.update', {}, configUpdateHandler);
          };



        }] // controller
    }); // component

// klammerfriedhof
}());
